import React, { Component } from 'react';
import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../../store/reducers';
import Select from '../Select';
import { getNumberOfRoomsOptions, formatPrice, calculatePercentage } from '../../utils';
import {getRoomPrice} from '../../apiHelpers';
import RoomOfferGallery from './RoomOfferGallery';
import withLocalize from '../../withLocalize';
import {RoomOfferAttributes} from "./RoomOfferAttributes";
import RoomType from "../../enums/RoomType";

class RoomOffer extends Component {

	initLightGallery = ref => {
		this.lightGallery = ref;

		window.lightGallery(ref, {
			download: false
		});
	};

	componentWillUnmount() {
		// Unmount lightgallery.js
		if (this.lightGallery && this.lightGallery.getAttribute('lg-uid') && window.lgData) {
			window.lgData[this.lightGallery.getAttribute('lg-uid')].destroy();
		}
	}

	render() {
		const {
			formValues: { currency },
			roomOffer,
			noOfNights,
			guestTypes,
			translate: t,
			translatePropertyValue,
			translateSelectOptions,
			boardBases,
			defaultGuests,
			defaultMaxPpr,
			apiRoomsResponse,
			showPercentageDiscounts,
		} = this.props;


		const messages = [];
		if (Number.isInteger(roomOffer.id) /* jedná se o typ pokoje a ne o konkrétní pokoj */ && roomOffer.noOfVacant > 0 && roomOffer.noOfVacant < 3) {
			messages.push(t('Rooms.RoomOffer.onlyLeft', { count: roomOffer.noOfVacant }));
		}
		if (noOfNights < roomOffer.minNights) {
			messages.push(t('Rooms.RoomOffer.minNights', { count: roomOffer.minNights }));
		}

		const extraFees = apiRoomsResponse ? apiRoomsResponse.extraFees : null;
		const pricelistFees = apiRoomsResponse ? apiRoomsResponse.pricelistFees : {};

		const isMinNightsBlocked = noOfNights < roomOffer.minNights;

		return (
			<div className={`room-offer ${this.props.isLast ? 'room-offer--last' : ''} ${roomOffer.noOfVacant === 0 ? 'room-offer--disabled' : ''}`}>

				{roomOffer.photos && roomOffer.photos.length > 0 &&
					<RoomOfferGallery roomOffer={roomOffer} />
				}
				<div className="room-offer__text-container">
					<h2 className="room-offer__room-name">{translatePropertyValue(roomOffer.name)}</h2>
					{messages.length > 0 &&
					<span className="room-offer__availability">{messages.join(' ')}</span>
					}
					<RoomOfferAttributes
						roomOffer={roomOffer}
						pricelistFees={pricelistFees}
						boardBases={boardBases}
					/>
					{translatePropertyValue(roomOffer.description) &&
					<p className="room-offer__description">{translatePropertyValue(roomOffer.description)}</p>
					}
					<div className="room-offer-count">
						<div className="room-offer-count__price-container">
							{isMinNightsBlocked ? (
							<div className="room-offer-count__price room-offer-count__price--min-nights">
								{t('Rooms.RoomOffer.minNightsPrice', { count: roomOffer.minNights })}
							</div>
							) : (
							<React.Fragment>
							<div className="room-offer-count__price">
								{(() => {
									const personCount = this.props.hideFullOccupancyPrices ? Math.min(this.props.priceDisplayGuestCount, roomOffer.beds + roomOffer.extrabeds) : null;
									const originalPrice = getRoomPrice(roomOffer, currency, personCount, null, boardBases, extraFees, pricelistFees, noOfNights, true);
									const price = getRoomPrice(roomOffer, currency, personCount, null, boardBases, extraFees, pricelistFees, noOfNights);
									return [
										originalPrice ? (
											<span className="room-offer-count__original_price">
												<span className="room-offer-count__original_price--price">{formatPrice(originalPrice, currency)}</span>
												{showPercentageDiscounts &&
													<span className="room-offer-count__original_price--percentage">({calculatePercentage(price, originalPrice)}&nbsp;%)</span>
												}
											</span>
										) : null,
										formatPrice(price, currency),
										<span className="room-offer-count__persons">({t('Rooms.RoomOffer.forPersons', { count: this.props.hideFullOccupancyPrices ? personCount : roomOffer.beds + roomOffer.extrabeds })})</span>,
									];
								})()}
							</div>
							{!this.props.hideFullOccupancyPrices && getRoomPrice(roomOffer, currency, 1, null, boardBases, extraFees, pricelistFees, noOfNights) !== getRoomPrice(roomOffer, currency, null, null, boardBases, extraFees, pricelistFees, noOfNights) &&
							<div
								className="room-offer-count__price room-offer-count__price--per-person"
							>
								{(() => {
									const originalPricePerPerson = getRoomPrice(roomOffer, currency, 1, null, boardBases, extraFees, pricelistFees, noOfNights, true);
									const pricePerPerson = getRoomPrice(roomOffer, currency, 1, null, boardBases, extraFees, pricelistFees, noOfNights);
									return [
										originalPricePerPerson ? (
											<span className="room-offer-count__original_price room-offer-count__original_price--per-person">
												<span className="room-offer-count__original_price--price">{formatPrice(originalPricePerPerson, currency)}</span>
												{showPercentageDiscounts &&
													<span className="room-offer-count__original_price--percentage">({calculatePercentage(pricePerPerson, originalPricePerPerson)}&nbsp;%)</span>
												}
											</span>
										) : null,
										formatPrice(pricePerPerson, currency),
										<span className="room-offer-count__persons">({t('Rooms.RoomOffer.forPersons', { count: 1 })})</span>,
									];
								})()}

							</div>
							}
							</React.Fragment>
							)}
						</div>
						<Field
							component={Select}
							name={`rooms[${roomOffer.id}]`}
							label={t('Rooms.RoomOffer.selectNoOfRooms')}
							className="room-offer-count__select"
							disabled={isMinNightsBlocked}
							options={translateSelectOptions(getNumberOfRoomsOptions(Object.keys(roomOffer.rooms).length, RoomType.getRoomType(translatePropertyValue(roomOffer.name))))}
							clearable={true}
							normalize={(value) => {
								// Ukladani do storage
								const rooms = [];

								for (let i = 0; i < value; i++) {
									const guestTypesItems = {};

									Object.values(guestTypes).map(guestType =>
										guestTypesItems[guestType.id] = guestType.default
											? (defaultMaxPpr // je výchozí počet hostů maximální dle kapacity pokoje?
												? roomOffer.beds + roomOffer.extrabeds
												: Math.min(defaultGuests, roomOffer.beds + roomOffer.extrabeds)
											) : 0
									);

									rooms.push({
										...roomOffer,
										guestTypes: guestTypesItems,
									});
								}

								return rooms;
							}}
							format={(value, name) => {
								// Cteni ze storage
								return value ? value.length : undefined;
							}}
						/>
					</div>

				</div>
			</div>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		noOfNights: state.app.noOfNights,
		guestTypes: state.app.guestTypes,
		defaultMaxPpr: state.app.defaultMaxPpr,
		boardBases: state.app.boardBases,
		defaultGuests: state.app.guests,
		hideFullOccupancyPrices: state.app.hideFullOccupancyPrices,
		priceDisplayGuestCount: state.app.priceDisplayGuestCount,
		apiRoomsResponse: state.app.apiRoomsResponse,
		showPercentageDiscounts: state.app.showPercentageDiscounts,
	})),
	withLocalize,
)(RoomOffer);



// WEBPACK FOOTER //
// ./src/components/Rooms/RoomOffer.jsx